
function WelcomeContent() {
  return (
    <div className="basis-2/3 flex flex-col py-3">
      <div className="text-purple-3 font-alegreya font-bold text-4xl">
        <span className="text-3xl text-black">Szukajcie aż znajdziecie</span>
      </div>
      <div className="text-base font-inter text-mdr">
        Każda historia się kiedyś kończy tylko po to, żeby inna mogła się zacząć.
      </div>
    </div>
  );
}

export default WelcomeContent;
